module.exports = __webpack_public_path__ + "img/var_db.7426c95.svg";